import React from "react"
import ContentLoader from "react-content-loader";

const DVtabsLoader = (props) => {
    return(
        <ContentLoader
            height={40}
            width={'100%'}
            viewBox="0 0 100% 40"
            {...props}>
        <rect x="30" y="10" rx="12" ry="12" width="180" height="27" />
        <rect x="215" y="10" rx="12" ry="12" width="180" height="27" />
        <rect x="400" y="10" rx="12" ry="12" width="180" height="27" />
      </ContentLoader>
    )
}
DVtabsLoader.metadata = {
    name: 'DaniloWoz',
    github: 'DaniloWoz',
    description: 'Simple Article',
    filename: 'DVtabsLoader',
  }
export default DVtabsLoader